<template>
  <b-card class="esg-base-card" no-body>
    <b-card-header>
      <esg-card-header v-if="header"
                       :title="title">
        <template #default>
          <slot name="header"></slot>
        </template>
        <template #actions>
          <slot name="actions"></slot>
        </template>
      </esg-card-header>
    </b-card-header>
    <b-card-body>
      <slot></slot>
    </b-card-body>
    <b-card-footer :class="{ 'd-none': !footer }">
      <slot name="footer"></slot>
    </b-card-footer>
  </b-card>
</template>

<script>
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";

export default {
  name: "EsgBaseCard",
  components: { EsgCardHeader },
  props: {
    title: {
      type: String,
      default: null
    },
    header: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true,
    }
  }
}
</script>

<style scoped>
.esg-base-card {
  border-radius: 20px;
  background-color: #FFF;
}

.card.esg-base-card .card-header {
  border-radius: 20px 20px 0 0;
  background-color: #FFF;
  padding: max(2vh, 1.5rem) 1.125rem max(2vh, 1.5rem) 1.125rem;
  display: flex;
  align-items: center;
  min-height: 3.5rem;
}

.card.esg-base-card .card-body {
  border-radius: 20px;
  background-color: #FFF;
  padding: 1rem;
}

.card.esg-base-card .card-footer {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: #FFF;
}
</style>
